/*
 * WHAT A ROUND INITIALS DISC PRINTS (entry 2 of `docs/use-case-rollout/walk/2026-10-02/HANDOFF_ABED_2026-10-02_WALK_2.md`,
 * unit XB). A production's initials are its own stored text (`customers.initials`, typed on its form or made
 * on save by `App\Helpers\Initials::generate()`), and the disc that prints them is 3rem wide at 16px with no
 * clipping, so "DEMO2026" ran out of its disc and over the name. Every disc that prints a production's
 * initials calls this one function; NO STORED VALUE CHANGES, only what the disc prints.
 *
 *   - upper case, every character that is not a letter or a digit left out, at most five (`max`);
 *   - null or undefined initials read as '';
 *   - where nothing is left, the first letter or digit of the name (upper case);
 *   - the size class: `font-size-16` for none to three characters, `font-size-12` (`_helper.scss`) for
 *     four or five;
 *   - `text` and `title` (the name, for the hover) are HTML-escaped, because most discs are built as HTML
 *     strings; a Vue template binds them itself and passes `escape: false`.
 *
 * The top bar's disc (`components/nav-bar.vue`) takes the same cleaning cut to THREE (`max: 3`) and ignores
 * the size class: it has its own size.
 *
 * Written as one plain `export function` with no import, so the harnesses that cut `SwitchEntity.vue`'s list
 * out of its source can prepend this file with its `export` word dropped (KNOWN.md rule 5).
 */
export function discInitials(initials, name, options) {
    var settings = options || {};
    var max = settings.max || 5;
    var escape = settings.escape !== false;
    var kept = function (value) {
        return Array.from(String(value === null || value === undefined ? '' : value).toUpperCase())
            .filter(function (character) { return /^[\p{L}\p{N}]$/u.test(character); });
    };
    var html = function (value) {
        return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    };

    var characters = kept(initials);
    if (characters.length === 0) {
        characters = kept(name).slice(0, 1);
    }
    characters = characters.slice(0, max);

    var text = characters.join('');
    var title = name === null || name === undefined ? '' : String(name);

    return {
        text: escape ? html(text) : text,
        size_class: characters.length >= 4 ? 'font-size-12' : 'font-size-16',
        title: escape ? html(title) : title
    };
}
